export default __webpack_public_path__ + "static/media/home.632bd761.svg";